const invoiceSearchStorageKey = (companyId: string) => `invoice-search:${companyId}`;

export function readStoredInvoiceSearch(companyId: string): string {
  const fromUrl = new URLSearchParams(window.location.search).get('q');
  if (fromUrl) {
    return fromUrl;
  }
  try {
    return sessionStorage.getItem(invoiceSearchStorageKey(companyId)) ?? '';
  } catch {
    return '';
  }
}

export function persistInvoiceSearch(companyId: string, value: string) {
  const trimmed = value.trim();
  try {
    if (trimmed) {
      sessionStorage.setItem(invoiceSearchStorageKey(companyId), value);
    } else {
      sessionStorage.removeItem(invoiceSearchStorageKey(companyId));
    }
  } catch {
    // sessionStorage может быть недоступен
  }
  const params = new URLSearchParams(window.location.search);
  if (trimmed) {
    params.set('q', value);
  } else {
    params.delete('q');
  }
  const qs = params.toString();
  const hash = window.location.hash;
  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${qs ? `?${qs}` : ''}${hash}`
  );
}

export function invoiceListPath(companyId: string): string {
  let q = '';
  try {
    q = sessionStorage.getItem(invoiceSearchStorageKey(companyId)) ?? '';
  } catch {
    q = '';
  }
  const params = new URLSearchParams();
  if (q.trim()) {
    params.set('q', q);
  }
  const qs = params.toString();
  return `/companies/${companyId}${qs ? `?${qs}` : ''}#invoices`;
}
